// Feature keys granted per user via the "features" list in localStorage
// (SessionStorageService.getFeatureKeys()). Each feature/module that gates
// UI behind a feature key adds its key here, under this single export,
// rather than as its own separate top-level constant.
export const ModuleFeatureKey = {
  DELIVERABLE_CREATE: "DELIVERABLE_CREATE",
  COA_CREATE: "COA_CREATE",
  TEMPLATE_CREATE: "RULE_ENGINE_TEMPLATE_CREATE",
  RULE_ENGINE_TEMPLATE_UPLOAD: "RULE_ENGINE_TEMPLATE_UPLOAD",
  RULE_ENGINE_TEMPLATE_EXPORT: "RULE_ENGINE_TEMPLATE_EXPORT",
  DELIVERABLE_VIEW: "DELIVERABLE_VIEW",
  TAX_FORM_ADMIN: "TAX_FORM_ADMIN",
  USER_MANAGEMENT_INVITE: "UserManagement_Invite",
} as const;
